import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailCampaignSubmittedComponent } from '../../components/email-campaign-submitted/email-campaign-submitted.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { EmailMailgunEachDirective } from '../../directives/email-mailgun-each.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  styleUrls: ['../../global-styles.less'],
  templateUrl: './campaign-submitted.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailMailgunEachDirective,
    EmailCampaignSubmittedComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class CampaignSubmittedTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<CampaignSubmittedTemplateData>;
}

export type Product = {
  title: string;
  duration: string;
  time_to_setup: string;
  price: string;
};

export type CampaignSubmittedTemplateData = {
  header: string;
  subheader_html: string;
  body: string;
  footer: string;
  order_summary: string;
  total: string;
  total_price: string;
  products: Product[];
  primary_cta: {
    href: string;
    label: string;
  };
};

export const CampaignSubmittedTemplateMocks: CampaignSubmittedTemplateData[] = [
  {
    header: 'Campaign successfully submitted',
    subheader_html: `Your campaign, <b>[Campaign Name]</b>, has been successfully submitted and payment has been completed.`,
    body: "We'll keep you updated on the status of each channel. You can also track these changes anytime through our app.",
    footer: 'Need help? support@recruitee.com',
    order_summary: 'Order summary:',
    total: 'Total: 1298 €',
    total_price: '1298 €',
    products: [
      {
        title:
          'Job Board Bundle - Social Media (28% discount) - LinkedIn, Facebook, Instagram, Reedit',
        duration: '30 days',
        time_to_setup: '3 days to publish',
        price: '848€',
      },
      {
        title: 'Bebee.com - Job posting Large',
        duration: '45 days',
        time_to_setup: '3 days to publish',
        price: '200€',
      },
      {
        title: 'LinkedIn - Job Posting',
        duration: '28 days',
        time_to_setup: '3 days to publish',
        price: '250€',
      },
    ],
    primary_cta: {
      href: 'https://tellent.com',
      label: 'View details',
    },
  },
];
